import React from 'react';
import { DashboardAccountMenu } from '../components/dashboard';

export default function CustomerDashboardHeader({
  accountMenuOpen,
  accountTriggerLabel,
  customerName,
  logout,
  navigate,
  onAccountMenuOpenChange,
  session,
}) {
  return (
    <DashboardAccountMenu
      className="customer-preview-account-menu"
      customerName={customerName}
      label={accountTriggerLabel}
      logout={logout}
      navigate={navigate}
      onOpenChange={onAccountMenuOpenChange}
      open={accountMenuOpen}
      overlayClassName="customer-preview-account-dropdown"
      session={session}
    />
  );
}
